export default __webpack_public_path__ + "static/media/review6.938c5d38.jpg";